import {createAction} from 'redux-actions';

import ActionTypes from './action-types';

export default {
    fetchMealRegistration: createAction(ActionTypes.MEAL_REGISTRATION_FETCH, (mealRegistrationId, institutionId) => ({
        mealRegistrationId,
        institutionId,
    })),
    fetchMealRegistrationSuccess: createAction(
        ActionTypes.MEAL_REGISTRATION_FETCH_SUCCESS,
        (mealRegistrationId, mealRegistration, institutionId) => ({
            mealRegistrationId,
            mealRegistration,
            institutionId,
        }),
    ),
    fetchMealRegistrationFailed: createAction(
        ActionTypes.MEAL_REGISTRATION_FETCH_FAILED,
        (mealRegistrationId, error) => ({mealRegistrationId, error}),
    ),
    createMealRegistrations: createAction(
        ActionTypes.MEAL_REGISTRATIONS_CREATE,
        (institutionId, childIds, mealType, mealItems, createdAt, mealPlanId, isV3) => ({
            institutionId,
            childIds,
            mealType,
            mealItems,
            createdAt,
            mealPlanId,
            isV3,
        }),
    ),
    createMealRegistrationsSuccess: createAction(
        ActionTypes.MEAL_REGISTRATIONS_CREATE_SUCCESS,
        persistedMealRegistrations => ({persistedMealRegistrations}),
    ),
    createMealRegistrationsFailed: createAction(ActionTypes.MEAL_REGISTRATIONS_CREATE_FAILED, error => ({error})),
    updateMealRegistration: createAction(
        ActionTypes.MEAL_REGISTRATION_UPDATE,
        (mealRegistration, mealType, mealItems, createdAt, mealPlanId, isV3) => ({
            mealRegistration,
            mealType,
            mealItems,
            createdAt,
            mealPlanId,
            isV3,
        }),
    ),
    updateMealRegistrationSuccess: createAction(
        ActionTypes.MEAL_REGISTRATION_UPDATE_SUCCESS,
        (mealRegistrationId, mealRegistration, updatedMealRegistration) => ({
            mealRegistrationId,
            mealRegistration,
            updatedMealRegistration,
        }),
    ),
    updateMealRegistrationFailed: createAction(
        ActionTypes.MEAL_REGISTRATION_UPDATE_FAILED,
        (mealRegistrationId, error) => ({mealRegistrationId, error}),
    ),
    deleteMealRegistration: createAction(ActionTypes.MEAL_REGISTRATION_DELETE, mealRegistrationId => ({
        mealRegistrationId,
    })),
    deleteMealRegistrationSuccess: createAction(ActionTypes.MEAL_REGISTRATION_DELETE_SUCCESS, mealRegistrationId => ({
        mealRegistrationId,
    })),
    deleteMealRegistrationAborted: createAction(ActionTypes.MEAL_REGISTRATION_DELETE_ABORTED, mealRegistrationId => ({
        mealRegistrationId,
    })),
    deleteMealRegistrationFailed: createAction(
        ActionTypes.MEAL_REGISTRATION_DELETE_FAILED,
        (mealRegistrationId, error) => ({mealRegistrationId, error}),
    ),
};
